import ExpandableChartCard from "../../../../shared/charts/ExpandableChartCard";
import ComboChart, { toComboArrays } from "./ComboChart";

/**
 * Utilisation Rate — Actual vs Forecast (restored to the legacy
 * ComboChart style per user request). Past months render as solid bars
 * with value labels, future months render as a dashed forecast line
 * with a soft area fill, target is a dashed horizontal line, and a
 * NOW separator marks the boundary.
 */
export default function UtilisationTrendChart({ data, canSee, target, right }) {
  if (!canSee) return null;
  const { actual, forecast } = toComboArrays(data, "Actual", "Forecast");
  return (
    <ExpandableChartCard
      title="Utilisation Rate — Actual vs Forecast"
      subtitle={`Monthly average · Target ${target}% · Live data pending from external system`}
      right={right}
      renderChart={({ expanded }) => (
        <>
          <ComboChart
            actual={actual}
            forecast={forecast}
            target={Number(target) || 85}
            unit="%"
            label="util"
            height={expanded ? 360 : 220}
            actualColor="#3b7ffa"
            forecastColor="#60a5fa"
            targetColor="#f59e0b"
          />
          <Legend />
        </>
      )}
    />
  );
}

function Legend() {
  return (
    <div className="flex items-center gap-4 mt-2 text-[11px] text-rc-text-secondary">
      <span className="inline-flex items-center gap-1.5"><span className="w-3 h-1 rounded-sm bg-[#3b7ffa]"/> Actual</span>
      <span className="inline-flex items-center gap-1.5"><span className="w-4 h-px border-t border-dashed border-[#60a5fa]"/> Forecast</span>
      <span className="inline-flex items-center gap-1.5"><span className="w-4 h-px border-t border-dashed border-[#f59e0b]"/> Target</span>
    </div>
  );
}
